module.exports = __webpack_public_path__ + "img/info3.aec11112.svg";